import React from 'react';

export const SilverSingle = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <ellipse cx="11.9999" cy="12" rx="11.9999" ry="12" fill="url(#paint0_linear_1934_153462)" />
        <defs>
            <linearGradient
                id="paint0_linear_1934_153462"
                x1="11.9999"
                y1="0"
                x2="11.9999"
                y2="24"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#728290" />
                <stop offset="1" stopColor="#C7D2DB" />
            </linearGradient>
        </defs>
    </svg>
);
